import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  increment,
  updateDoc,
} from "firebase/firestore";

import ListShareMenu from "../../components/ListShareMenu";
import { useParams } from "react-router-dom";

import { getBaseURL } from "../../lib/getBaseURL";
import { db } from "../../FirebaseConfig";
import { UserAuth } from "../../Context";
import Settings from "../../ShoppingList/Settings";
import useModalStore from "../../StatesStore/ModalStore";
import { toast } from "react-toastify";
import { toastOptions } from "../../lib/toastOptions";
import BottomTray from "../../Trays/BottomTray";
import DeleteList from "../../Trays/DeleteList";
import ShareShoppingList from "../../Trays/ShareShoppingList";
import { useEffect, useState } from "react";

const FavoritesMoreUserProfile = ({
  list,
  listId,
  productId,
  userId,
  listLink,
  BackgroundOnSvg,
  showShareButton,
  imageWidth = "32px",
  svgWidth = "15px",
  type,
  name,
}) => {
  const { user } = UserAuth();
  const { uid } = useParams();
  const { openModal } = useModalStore();
  const docId = listId || productId;
  const [isOpenDeleteTray, setIsOpenDeleteTray] = useState(false);
  const [isOpenShareTray, setIsOpenShareTray] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const closeOtherDropdown = () => {
    let dropdowns = document.getElementsByClassName(`Other`);
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains(docId)) {
        if (dropdown.classList.contains("show")) {
          dropdown.classList.remove("show");
          dropdown.children[0].classList.remove("show");
          dropdown.children[0].ariaExpanded = "false";
          dropdown.children[1].classList.remove("show");
        } else {
          dropdown.classList.add("show");
          dropdown.children[0].classList.add("show");
          dropdown.children[0].ariaExpanded = "true";
          dropdown.children[1].classList.add("show");
        }
      } else {
        dropdown.classList.remove("show");
        dropdown.children[0].classList.remove("show");
        dropdown.children[0].ariaExpanded = "false";
        dropdown.children[1].classList.remove("show");
      }
    });
  };
  const handleClick = () => {
    const DATA = {
      deleteFunction: handleDeleteFavorite,
      displayName: name,
    };
    openModal("ConfirmDelete", type, DATA);
  };

  const handleDeleteFavorite = async () => {
    if (!user?.uid) {
      toast.error("Please log in to manage favorites");
      return;
    }

    try {
      // Use productId if listId is not available

      if (!docId) return;

      const favoriteRef = doc(db, "users", userId, "favorites", docId);

      await deleteDoc(favoriteRef);

      toast.success("Removed from favorites", toastOptions);
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toast.error(`Failed to remove from favorites`, toastOptions);
    }
  };
  return (
    <>
      <style jsx>
        {`
          .buttonStyle {
            padding: 10px 16px;
          }
          .buttonStyle:hover {
            backgroundcolor: #e9eaed;
          }
        `}
      </style>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`dropdown ${docId} Other`}
      >
        <div
          className={`p-0 dropdown-toggle`}
          role="button"
          id={`${docId}Dropdown`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => {
            closeOtherDropdown();
          }}
        >
          <div
            style={{
              width: imageWidth,
              height: imageWidth,
            }}
            className="d-flex align-items-center justify-content-end"
          >
            <svg
              style={{
                width: svgWidth,
                height: svgWidth,
              }}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99712 5.83333C9.07662 5.83333 8.33045 5.08714 8.33045 4.16667C8.33046 3.24619 9.07662 2.5 9.99712 2.5C10.9176 2.5 11.6638 3.24619 11.6638 4.16667C11.6638 5.08714 10.9176 5.83333 9.99712 5.83333Z"
                fill="#14191F"
              />
              <path
                d="M10 11.6666C9.07952 11.6666 8.33335 10.9205 8.33335 9.99998C8.33335 9.07948 9.07952 8.33331 10 8.33331C10.9205 8.33331 11.6667 9.07948 11.6667 9.99998C11.6667 10.9205 10.9205 11.6666 10 11.6666Z"
                fill="#14191F"
              />
              <path
                d="M9.99712 17.5C9.07662 17.5 8.33045 16.7538 8.33045 15.8333C8.33046 14.9128 9.07662 14.1666 9.99712 14.1666C10.9176 14.1666 11.6638 14.9128 11.6638 15.8333C11.6638 16.7538 10.9176 17.5 9.99712 17.5Z"
                fill="#14191F"
              />
            </svg>
          </div>
        </div>
        <ul
          className="dropdown-menu dropdown-menu-end mt-0 py-2"
          aria-labelledby={`${docId}Dropdown`}
          style={{
            cursor: "pointer",
            fontSize: "18px",
            fontWeight: 500,
            fontFamily: "Inter",
            borderRadius: "16px",
            color: "#667085",
            width: "260px",
            boxShadow: "0px 0px 8px 0px #00000026",
          }}
        >
          <>
            <li
              style={{
                borderRadius: "0px 0px 16px 16px",
              }}
              className="buttonStyle"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {isSmallScreen ? (
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    setIsOpenShareTray(true);
                    closeOtherDropdown();
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      style={{ width: "20px", height: "20px" }}
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.74817 9.00024C6.74817 10.0358 5.9087 10.8752 4.87317 10.8752C3.83764 10.8752 2.99817 10.0358 2.99817 9.00024C2.99817 7.96472 3.83764 7.12524 4.87317 7.12524C5.9087 7.12524 6.74817 7.96472 6.74817 9.00024Z"
                        stroke="#676A79"
                        stroke-width="1.00899"
                      />
                      <path
                        d="M10.4989 4.87476L6.7489 7.49976"
                        stroke="#676A79"
                        stroke-width="1.00899"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10.4989 13.1246L6.7489 10.4996"
                        stroke="#676A79"
                        stroke-width="1.00899"
                        stroke-linecap="round"
                      />
                      <path
                        d="M14.2496 13.875C14.2496 14.9105 13.4102 15.75 12.3746 15.75C11.3391 15.75 10.4996 14.9105 10.4996 13.875C10.4996 12.8395 11.3391 12 12.3746 12C13.4102 12 14.2496 12.8395 14.2496 13.875Z"
                        stroke="#676A79"
                        stroke-width="1.00899"
                      />
                      <path
                        d="M14.2496 4.12549C14.2496 5.16102 13.4102 6.00049 12.3746 6.00049C11.3391 6.00049 10.4996 5.16102 10.4996 4.12549C10.4996 3.08996 11.3391 2.25049 12.3746 2.25049C13.4102 2.25049 14.2496 3.08996 14.2496 4.12549Z"
                        stroke="#676A79"
                        stroke-width="1.00899"
                      />
                    </svg>
                  </BackgroundOnSvg>

                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                    }}
                  >
                    Share
                  </span>
                </div>
              ) : (
                <ListShareMenu
                  list={list}
                  listName={list?.name}
                  myName={user?.displayName}
                  listLink={listLink}
                  listId={list?.listId}
                  userId={user?.uid}
                  products={list?.products}
                  BackgroundOnSvg={BackgroundOnSvg}
                  componentName={"favoritesMoreUserProfile"}
                  closeOtherDropdown={closeOtherDropdown}
                />
              )}
            </li>

            {user?.uid === uid && (
              <li
                style={{
                  borderRadius: "0px 0px 16px 16px",
                }}
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    if (isSmallScreen) {
                      setIsOpenDeleteTray(true);
                    } else {
                      handleClick();
                    }
                    closeOtherDropdown();
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.16671 16.6665C4.16671 17.5832 4.91671 18.3332 5.83337 18.3332H14.1667C15.0834 18.3332 15.8334 17.5832 15.8334 16.6665V4.99984H4.16671V16.6665ZM5.83337 6.6665H14.1667V16.6665H5.83337V6.6665ZM13.75 2.49984L12.9167 1.6665H7.08337L6.25004 2.49984H3.33337V4.1665H16.6667V2.49984H13.75ZM10.8334 14.9998V8.33317H12.5V14.9998H10.8334ZM7.50004 8.33317L7.50004 14.9998H9.16671V8.33317H7.50004Z"
                        fill="#FF3742"
                      />
                    </svg>
                  </BackgroundOnSvg>

                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#FF3742",
                    }}
                  >
                    Delete {type}
                  </span>
                </div>
              </li>
            )}
          </>
        </ul>
      </div>
      <BottomTray
        text={`Share ${type}`}
        isOpen={isOpenShareTray}
        setIsOpen={setIsOpenShareTray}
      >
        <ShareShoppingList
          products={list?.products}
          userId={user?.uid}
          setShow={setIsOpenShareTray}
          listLink={listLink}
        />
      </BottomTray>
      <BottomTray
        text={`Delete ${type}`}
        isOpen={isOpenDeleteTray}
        setIsOpen={setIsOpenDeleteTray}
      >
        <DeleteList handleDeleteList={handleDeleteFavorite} listName={name} />
      </BottomTray>
    </>
  );
};

export default FavoritesMoreUserProfile;
